import React, { useState } from "react";
import { Modal, Upload, Input, DatePicker, Select } from "antd";
import { Icon } from "@iconify/react";
import Button from "../components/shared/button";
import Input_Field from "../components/shared/input";

const { Dragger } = Upload;
const { Option } = Select;

const ContractAddModal = ({ isaddnewModelOpen, setisaddnewModelOpen }) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileList, setFileList] = useState([]);
  const cases = ["Medical", "Marriage", "Land", "Other"];

  const handleOk = () => {
    setisaddnewModelOpen(false);
  };

  const handleCancel = () => {
    setisaddnewModelOpen(false);
    setIsUploaded(false); // Reset state when modal closes
    setFileList([]);
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0) {
      setIsUploaded(true);
    } else {
      setIsUploaded(false);
    }
  };

  const handleRemoveFile = () => {
    setFileList([]);
    setIsUploaded(false); // Show the upload dragger again
  };

  return (
    <Modal
      open={isaddnewModelOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="del-modal"
      centered={true}
      width="65%"
    >
      <div className="modal-content rounded-[19px] min-h-[90vh] overflow-y-auto flex flex-col justify-between items-center py-[22px] px-[50px] max-sm:px-[20px]">
        <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
          Add Document
        </h5>

        {isUploaded ? (
          <div className="form-view w-full flex flex-col items-center space-y-[21px]">
            <div className="uploaded-file-preview pt-[19px] pb-[32px] px-[19px] flex flex-col items-center justify-between border-dashed border-[#999999] border-2 max-w-[327px] w-full rounded-[17px]">
              <div className="relative">
                <img src="../../assets/images/dashboard/fileImg.png" alt="" />
                <Icon
                  icon="mdi:cross-circle"
                  width={22}
                  height={22}
                  color="#143A62"
                  onClick={handleRemoveFile}
                  className="cursor-pointer absolute top-[-4%] right-[-4%]"
                />
              </div>
              <p className="e-small font-semibold text-[#999] mt-[3px]">
                {fileList[0].name}
              </p>
            </div>
          </div>
        ) : (
          // Display upload dragger initially
          <Dragger
            name="file"
            multiple={false}
            fileList={fileList}
            onChange={handleUploadChange}
            beforeUpload={() => false} // Prevent auto-upload
            className="upload-div w-full max-w-[526px] h-[226px] mt-[14px] border-dashed border-[#999999] border-2 flex flex-col items-center justify-center rounded-[17px]"
          >
            <Icon
              icon="material-symbols:upload"
              width={60}
              height={60}
              color="#999999"
              className="m-auto"
            />
            <p className="medium text-[#999] font-semibold">Upload file</p>
            <p className="text-[#999] font-semibold e-small">
              Filetype: PDF, DOCX, PPT
            </p>
          </Dragger>
        )}
        <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
          <div className="w-full">
            <p className="text-blue font-medium font-manrope medium">
              File Type
            </p>
            <Select
              placeholder="Select"
              className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
            >
              {cases.map((caseItem, index) => (
                <Option key={index} value={caseItem}>
                  {caseItem}
                </Option>
              ))}
            </Select>
          </div>
          <Input_Field
            label="Contract Name"
            type="text"
            name="Case Management"
            placeholder="Case Management"
            className="dash-input-field"
            wrapperClass="dash-wrapper"
            labelClass="dash-label"
          />
        </div>

        <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
          <div className="w-full">
            <p className="text-blue font-medium font-manrope medium">
              Effective Date
            </p>
            <DatePicker className="w-full mt-[6px]" />
          </div>
          <div className="w-full">
            <p className="text-blue font-medium font-manrope medium">
              Expiry Date
            </p>
            <DatePicker className="w-full mt-[6px]" />
          </div>
        </div>
        <div className="flex gap-[14px] w-full mt-[14px] ">
          <div className="w-full">
            <p className="text-blue font-medium font-manrope medium">
              Contract Type
            </p>
            <Select
              placeholder="Case Management"
              className="reminder-case w-full mt-[6px] rounded-[10px] bg-white"
            >
              {cases.map((caseItem, index) => (
                <Option key={index} value={caseItem}>
                  {caseItem}
                </Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="w-full mt-[14px] ">
          <p className="text-blue font-medium font-manrope medium">
            Description
          </p>
          <Input.TextArea placeholder="Type" rows={5} className="mt-[6px]" />
        </div>
        <Button
          text="Save"
          className="button btn-blue !rounded-[39px] large mt-[14px]"
          height={45}
          width={176}
          onClick={handleCancel}
        />
      </div>
    </Modal>
  );
};

export default ContractAddModal;
